
import { FC } from "react";
import React from 'react';
import { Container, List, ListItem, Typography, Link } from '@mui/material';

export const PrivacyPolicyPage: FC = () => {
  return (
    <Container component="main" maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        プライバシーポリシー
      </Typography>

      <Typography variant="h5" gutterBottom>
        お客様から取得する情報
      </Typography>
      <List>
        <ListItem>氏名（ニックネームやペンネームも含む）</ListItem>
        <ListItem>年齢または生年月日</ListItem>
        <ListItem>性別</ListItem>
        <ListItem>職業、職歴、学歴</ListItem>
        <ListItem>メールアドレス</ListItem>
        <ListItem>電話番号</ListItem>
        <ListItem>住所</ListItem>
        <ListItem>写真や動画</ListItem>
        <ListItem>クレジットカード、銀行口座、電子マネー等の決済手段に関する情報</ListItem>
        <ListItem>外部サービスでのID、その他外部サービスのプライバシー設定により公開を許可された情報</ListItem>
        <ListItem>Cookieを用いた識別情報</ListItem>
        <ListItem>OSが生成するID、端末の種類、端末識別子等のデバイス情報</ListItem>
        <ListItem>ウェブサイトの滞在時間、入力履歴、購買履歴等の行動履歴</ListItem>
        <ListItem>アプリの起動時間、入力履歴、購買履歴等の利用履歴</ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        お客様の情報を利用する目的
      </Typography>
      <List>
        <ListItem>サービスに関する登録の受付、本人確認、認証</ListItem>
        <ListItem>サービスの利用履歴の管理</ListItem>
        <ListItem>利用料金の決済</ListItem>
        <ListItem>サービスの維持改善のための行動履歴の分析</ListItem>
        <ListItem>サービス関連の情報の提供</ListItem>
        <ListItem>ユーザーからの問い合わせへの対応</ListItem>
        <ListItem>規約や法令に違反する行為への対応</ListItem>
        <ListItem>サービスの変更、終了の通知</ListItem>
        <ListItem>規約の変更の通知</ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        第三者提供について
      </Typography>
      <List>
        <ListItem>個人データの取扱いを外部委託する場合</ListItem>
        <ListItem>事業の買収時</ListItem>
        <ListItem>共同利用する事業パートナー（具体的な内容は別途公表）</ListItem>
        <ListItem>法律に基づく正当な理由がある場合</ListItem>
      </List>

      <Typography variant="h5" gutterBottom>
        アクセス解析ツール
      </Typography>
      <Typography>
        当社は、「Googleアナリティクス」を使用しており、トラフィックデータの収集にはCookieを使用します。これは完全に匿名で行われ、個人を特定するものではありません。詳細は
        <Link href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank">こちら</Link>。
      </Typography>
      <Typography variant="h5" gutterBottom>
        Google広告のデータ処理
      </Typography>
      <Typography>
        当社アプリケーションでは、Google広告のAPIを利用しております。これには、Google広告アカウントのデータの参照、編集、作成、および削除が含まれます。これにより、お客様の広告のパフォーマンスを向上させ、より効果的な広告戦略を実施するための洞察を提供します。当社はお客様の広告データを厳密に管理し、これらの情報はお客様の事前の同意なく第三者に公開されることはありません。
      </Typography>
      <Typography variant="h5" gutterBottom>
        プライバシーポリシーの変更
      </Typography>
      <Typography>
        プライバシーポリシーは必要に応じて変更されることがあります。変更内容はウェブサイト上で通知されます。
      </Typography>

      <Typography variant="h5" gutterBottom>
        お問い合わせ
      </Typography>
      <Typography>
        情報の開示、訂正、利用停止、削除を希望する場合は、<Link href="mailto:info@zero-one.llc">info@zero-one.llc</Link>までご連絡ください。
      </Typography>
    </Container>
  );
};

// export default PrivacyPolicyPage;

